import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

import customBackgroundByUser from '../../../store/customBackground';
import styleClasses from '../css/mobile/MusicardDetail.module.scss';

import LeftMenu from './LeftMenu';
import CDPlayer from './CDPlayer';

const MusicardPreview = () => {
  const { id } = useParams();
  const [musician, setMusician] = useState(null);
  const [styleData, setStyleData] = useState(null);
  const [customHtml, setCustomHtml] = useState('');
  const [customNameHtml, setCustomNameHtml] = useState('');

  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
  
    return () => {
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
    };
  }, []);

  useEffect(() => {
    document.body.style.overflowY = 'auto';
    document.documentElement.style.overflowY = 'auto';

    // 스크롤바 시각적으로 숨김
    const style = document.createElement('style');
    style.innerHTML = `
        ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
        }
        body {
        -ms-overflow-style: none;
        scrollbar-width: none;
        }
    `;
    document.head.appendChild(style);

    return () => {
        document.body.style.overflowY = '';
        document.documentElement.style.overflowY = '';
        style.remove();
    };
    }, []);


  useEffect(() => {
    const fetchData = async () => {
        try {
        const docRef = doc(db, 'musicians', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setMusician(docSnap.data());
        }
    
        const styleRef = doc(db, `musicians/${id}/style`, 'main');
        const styleSnap = await getDoc(styleRef);
        const custom = customBackgroundByUser.find((c) => c.id === id);
    
        let finalCSS = '';
    
        if (styleSnap.exists()) {
            const data = styleSnap.data();
            setStyleData(data);
    
            if (data.font) {
            const fontName = extractFontName(data.font);
            if (fontName) {
                if (data.font.includes('fonts.googleapis.com')) {
                finalCSS += `@import url('${data.font}');\n`;
                } else {
                finalCSS += `
                    @font-face {
                    font-family: '${fontName}';
                    src: url('${data.font}') format('${
                        data.font.endsWith('.woff2')
                        ? 'woff2'
                        : data.font.endsWith('.woff')
                        ? 'woff'
                        : 'truetype'
                    }');
                    font-weight: normal;
                    font-style: normal;
                    }
                `;
                }
                const fontColor = data.fontcolor || '#fff';
                finalCSS += `body { .musicardContainer * { font-family: '${fontName}', sans-serif; color: ${fontColor}; } }\n`;
            } else {
                finalCSS += `body { .musicardContainer * { color: ${data.fontcolor || '#fff'}; } }\n`;
            }
            } else if (data.fontcolor) {
            finalCSS += `body { .musicardContainer * { color: ${data.fontcolor}; } }\n`;
            }
        }
    
        // custom CSS
        if (custom?.css) {
            finalCSS += `\n${custom.css}`;
        }
    
        // 삽입
        if (finalCSS) {
            const styleEl = document.createElement('style');
            styleEl.id = 'preview-style';
            styleEl.innerHTML = finalCSS;
            document.head.appendChild(styleEl);
        }
    
        // custom nameHtml
        if (custom?.nameHtml) setCustomNameHtml(custom.nameHtml);
    
        // custom nameStyle
        if (custom?.nameStyle) {
            const nameStyle = document.createElement('style');
            nameStyle.id = 'preview-name-style';
            nameStyle.innerHTML = custom.nameStyle;
            document.head.appendChild(nameStyle);
        }
    
        // custom JS
        if (custom?.js) {
            const script = document.createElement('script');
            script.id = 'preview-script';
            script.type = 'text/javascript';
            script.innerHTML = custom.js;
            document.body.appendChild(script);
        }
    
        } catch (err) {
        console.error('Preview Load Error:', err);
        }
    
        return () => {
        document.getElementById('preview-style')?.remove();
        document.getElementById('preview-name-style')?.remove();
        document.getElementById('preview-script')?.remove();
        };
    };
    
    fetchData();
  }, [id]);      

  // 폰트 이름 추출 함수
  const extractFontName = (fontUrl) => {
    if (!fontUrl) return null;

    // 1. Google Fonts URL 형식 처리
    const googleFontsMatch = fontUrl.match(/family=([^:&]+)/);
    if (googleFontsMatch) {
        return decodeURIComponent(googleFontsMatch[1].replace(/\+/g, ' '));
    }

    // 2. 일반 URL에서 파일 이름 추출
    const urlSegments = fontUrl.split('/');
    const fileName = urlSegments[urlSegments.length - 1]; // 마지막 경로 (파일명)
    
    // 확장자 제거 (.woff, .ttf 등)
    const fontName = fileName.split('.')[0];
    return fontName || null;
  };

  if (!musician || !styleData) return null;

  return (
    <div
    style={{
      width: '360px',
    }}
  >
    <div
      className={`musicardContainer ${styleClasses.musicardContainerMobile}`}
      style={{ background: styleData.backgroundColor || '#0C0C12' }}
    >
      <div
        className={`customBackground ${styleClasses.customBackground}`}
        dangerouslySetInnerHTML={{ __html: customHtml }}
      ></div>

      <LeftMenu
        musician={styleData}
        isGroup={Boolean(musician.positions?.includes('Group/Band'))}
        setModalOpen={() => {}}
        setArchiveModal={() => {}}
        setPositionModal={() => {}}
        setActivityModal={() => {}}
        setContactModal={() => {}}
        setMembersModal={() => {}}
      />

      <div className={styleClasses.musicardDetail}>
        <div className={styleClasses.nameContainer}>
          {customNameHtml ? (
            <h1
              className={`name ${styleClasses.name}`}
              dangerouslySetInnerHTML={{
                __html: customNameHtml.replaceAll(
                  '[MUSICIAN_NAME]',
                  `${musician.name} ${musician.eng ?? ''}`
                ),
              }}
            />
          ) : (
            <h1
              className={`name ${styleClasses.name}`}
              dangerouslySetInnerHTML={{
                __html: `${musician.name} ${musician.eng ? `</br>${musician.eng}` : ''}`,
              }}
            />
          )}
        </div>

        <CDPlayer
          videoId={styleData.videoId || 'q3gKI9o8QhM'}
          videoTitle={styleData.videoTitle}
          thumbnail={styleData.CDThumbnail}
          styleData={styleData.dark}
          styleClasses={styleClasses}
        />

        {/* Music Links */}
        <div className={styleClasses.musicLinks}>
          {styleData.musicLinks &&
            Object.entries(styleData.musicLinks).map(([key, url]) => {
              const baseKey = key.replace(/\s*\d+$/, '').toLowerCase();
              return (
                <a>
                  <img
                    src={`/assets/icons/${baseKey}-icon${styleData.dark ? '_1' : ''}.png`}
                    alt={key}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `/assets/icons/etc-icon${styleData.dark ? '_1' : ''}.png`;
                    }}
                  />
                </a>
              );
            })}
        </div>

        {/* SNS Links */}
        <div className={styleClasses.snsLinks}>
          {styleData.sns &&
            Object.entries(styleData.sns).map(([key, url]) => {
              const baseKey = key.replace(/\s*\d+$/, '').toLowerCase();
              return (
                <a>
                  <img
                    src={`/assets/icons/${baseKey}-icon${styleData.dark ? '_1' : ''}.png`}
                    alt={key}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `/assets/icons/etc-icon${styleData.dark ? '_1' : ''}.png`;
                    }}
                  />
                </a>
              );
            })}

            {/* 링크 복사 아이콘 */}
            <a>
              <img 
                src={`/assets/icons/share-icon${ styleData.dark ? '_1' : '' }.png`} alt="Copy link" />
            </a>
        </div>

        {/* Hit Count (고정 표시) */}
        <div className={styleClasses.hitCountWrapper}>
          <div className={styleClasses.hitCard}>
            <div className={styleClasses.hitLabel}>TODAY</div>
            <div className={styleClasses.hitValue}>29</div>
          </div>
          <div className={styleClasses.hitCard}>
            <div className={styleClasses.hitLabel}>TOTAL</div>
            <div className={styleClasses.hitValue}>1,023</div>
          </div>
        </div>

        {/* 장르 및 포지션 */}
        <div className={styleClasses.infoSection}>
          <div className={styleClasses.genres}>
            {musician.genres?.join(' · ')}
          </div>
          <div className={styleClasses.positions}>
            {musician.positions?.join(' · ')}
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default MusicardPreview;
